import { useRef, useState, useCallback } from "react";

/**
 * Custom hook to manage textarea height dynamically based on content
 */
export const useTextareaHeight = () => {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const [inputHeight, setInputHeight] = useState(40);

  const adjustHeight = useCallback(() => {
    if (inputRef?.current) {
      inputRef.current.style.height = "42px";
      inputRef.current.style.height = `${inputRef?.current?.scrollHeight}px`;
      setInputHeight(inputRef.current.scrollHeight);
    }
  }, []);

  const handleInput = useCallback((e: React.FormEvent<HTMLTextAreaElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
    const target = e.target as HTMLTextAreaElement;

    if (!target) return;

    if (target.value.trim().length === 0) {
      target.style.height = "50px";
      setInputHeight(50);
      return;
    }

    target.style.height = "auto";
    target.style.height = `${target.scrollHeight}px`;
    setInputHeight(target.scrollHeight);
  }, []);

  return {
    inputRef,
    inputHeight,
    adjustHeight,
    handleInput,
  };
};
